import { get } from 'lodash-es'

import GETTER_TYPES from '../getter-types'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'

export const getAvailabilityWatchGetters = MUTATION_TYPES => ({
  [GETTER_TYPES.AVAILABILITYWATCH_PENDING]: state =>
    [REQUEST_STATE.STATE_INITIAL, REQUEST_STATE.STATE_PENDING].includes(
      get(state, MUTATION_TYPES.AVAILABILITYWATCH.stateKey, REQUEST_STATE.STATE_FAILURE),
    ),
  [GETTER_TYPES.AVAILABILITYWATCH_IS_SKU_ON_LIST]: state => code => {
    return Array.isArray(state[MUTATION_TYPES.AVAILABILITYWATCH.dataKey])
      ? state[MUTATION_TYPES.AVAILABILITYWATCH.dataKey].includes(code)
      : false
  },
})
